export default __webpack_public_path__ + "static/media/business-clipart-transparent-background-5.c50eae05.png";